// extracted by mini-css-extract-plugin
export default {"editPageContent":"SKzkt","loaderWrapper":"xA7UF","loader":"lSmtF","leftContent":"VcnC0","leftMenuWrapper":"C0d4q","rightContent":"UTren","leftContentMenu":"WDO9Y","showed":"Dqsa2"};